import '@fontsource-variable/inter';
import './styles/main.css';

import { loadSite } from './lib/content.js';
import { renderIndex, renderProjectPage } from './lib/render.js';
import {
  initSmoothScroll,
  observeBlocks,
} from './lib/scroll.js';
import { initTracking } from './lib/tracking.js';

const app = document.getElementById('app');

const loader = document.createElement('div');
loader.className = 'app-loading';
loader.textContent = 'Loading';
document.body.appendChild(loader);

let siteData = null;

function currentSlug() {
  // Hash routing: `#/<slug>` → project page; empty → index.
  const h = window.location.hash || '';
  const m = h.match(/^#\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

function route() {
  if (!siteData) return;
  const slug = currentSlug();
  if (slug) {
    const project = siteData.projects.find((p) => p.slug === slug);
    if (project) {
      document.title = `${project.title || slug} — ${siteData.site.name || 'Studio'}`;
      renderProjectPage(app, siteData, project);
      window.scrollTo(0, 0);
      observeBlocks(app);
      return;
    }
    // Unknown slug: fall through to index.
    window.location.hash = '';
  }
  document.title = siteData.site.name
    ? `${siteData.site.name} — Studio`
    : 'Studio';
  renderIndex(app, siteData);
  window.scrollTo(0, 0);
}

(async function boot() {
  try {
    siteData = await loadSite();
  } catch (err) {
    console.error('[boot] failed to load site content', err);
    loader.textContent = 'Failed to load content. Check /content/index.json.';
    return;
  }

  initSmoothScroll();
  initTracking();
  window.addEventListener('hashchange', route);
  route();

  requestAnimationFrame(() => loader.classList.add('hidden'));
  setTimeout(() => loader.remove(), 600);
})();
